export default "__VITE_ASSET__05dfb321__"